export default __webpack_public_path__ + "static/media/mixpanel.60a04f13.svg";